import { useQueryClient } from '@tanstack/react-query'

import { useContactsServicePatchV1IndividualsByIndividualIdContactsByContactId } from '../client/queries'
import { useContactsServiceGetV1IndividualsByIndividualIdContactsKey } from '../client/queries/common'

export const useUpdateContact = () => {
  const queryClient = useQueryClient()

  return useContactsServicePatchV1IndividualsByIndividualIdContactsByContactId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useContactsServiceGetV1IndividualsByIndividualIdContactsKey],
      })
    },
  })
}
